import { Puestos } from "src/constants/puestos"
import { useColaborador } from "./colaborador"

export function useGetCamaristas(ignoreIds?: string[]) {
    const { data: camaristasData } = useColaborador(Puestos.RECAMARISTA)
    const { data: supervisoresData } = useColaborador(Puestos.SUPERVISOR)
    
    const camaristas = (camaristasData || []).map((r) => ({ ...r, puesto: "Camarista" }))
    const camaristaIds = new Set([...(camaristas.map((r) => r.colaborador_id)) || []])
    const camaritasAsignados = new Set(ignoreIds || [])
    // Un colaborador puede tener el puesto de Supervisor y Recamarista a la vez,
    // evitamos que aparezca dos veces en el dropdown
    const supervisoresSinDuplicar = (supervisoresData || [])
        .filter((r) => !camaristaIds.has(r.colaborador_id))
        .map((r) => ({ ...r, puesto: "Supervisor" }))
    
    return [...camaristas, ...supervisoresSinDuplicar].filter((r)=>!camaritasAsignados.has(r.colaborador_id))
}